import { Box } from '../'
import './index.scss'

const Image = ({ className = '', ...rest }) => {
  return <Box as='img' className={['Image', className]} {...rest} />
}

export default Image
